<template>
    <div style="margin-bottom: 10vh;">
        <ul style="list-style:none;margin:10px 0;">
            <li style="padding-bottom:12px;">
                <div>
                    <h3><a href="#">IDE</a></h3>
                    <hr>
                    <h4><b>Node.js, Express.js, HTML, CSS, JS, Docker, Python, EC2</b></h4>
                    <p>An Online IDE for running programs using docker and other node.js</p>
                    <p><a href="https://github.com/shobhit1997/Code_Compiler">Github</a></p>
                </div>
            </li>
            <li style="padding-bottom:12px;">
                <div>
                    <h3><a href="#">Technical Interview Portal</a></h3>
                    <hr>
                    <h4><b>Node.js,Express.js, HTML, CSS, JS, Docker, Python, EC2, Socket.io</b></h4>
                    <p>An Online platform for taking realtime programming interviews</p>
                    <p><a href="https://github.com/shobhit1997/interview-portal">Github</a></p>
                </div>
            </li>
            <li style="padding-bottom:12px;">
                <div>
                    <h3><a href="#">QHUB</a></h3>
                    <hr>
                    <h4><b>Node.js,Express.js,OAuth,JWT,Google API's,Templating,PostgreSQL</b></h4>
                    <p>It is a question bank, that provides its users functionality to create and post assignments and
                        question papers. Teachers can create assignments and post them to the college notice board directly
                        with one click.
                        <br>
                        Question papers can be created based on subjects, units, sections, compulsory questions, marks etc.
                        Also allows me to add images to questions.
                    </p>
                    <p><a href="https://github.com/shobhit1997/QHub">Github</a></p>
                </div>
            </li>
            <li style="padding-bottom:12px;">
                <div>
                    <h3><a href="https://play.google.com/store/apps/details?id=com.hackncs.zealicon.loot">Loot App</a></h3>
                    <hr>
                    <h4><b>Android, Node.js, MongoDB, Express.js, Redis, Firebase Firestore, Realtime DB, Firebase Auth,
                            FCM, AWS EC2</b></h4>
                    <p>An android app, location based game where a user find a mission at a random place in college.Solving
                        the mission player earns coins which he can bet for a duel with other online players on a small
                        game.The api's for the app are written on node.js</p>
                    <p><a href="https://github.com/ncs-jss/loot">Github Android</a></p>
                    <p><a href="https://github.com/ncs-jss/Loot-Backend">Github Backend</a></p>
                </div>
            </li>
            <li style="padding-bottom:12px;">
                <div>
                    <h3><a href="#">JSS Cricket App</a></h3>
                    <hr>
                    <h4><b>Ruby on Rails, PostgreSQL, Heroku</b></h4>
                    <p>An app to monitor the performance of JSS Cricket team and it’s players</p>
                    <p><a href="https://github.com/shobhit1997/jss-cricket-app">Github</a></p>
                </div>
            </li>
            <li style="padding-bottom:12px;">
                <div>
                    <h3><a href="http://oauth.shoa-apps.live/">Infoconnect OAuth</a></h3>
                    <hr>
                    <h4><b>Node.js, MongoDB, HTML, CSS, JSS</b></h4>
                    <p>An OAuth service of college registration portal for other college projects and portals. Visit the
                        github page for more details. </p>
                    <p><a href="https://github.com/shobhit1997/OAuth">Github</a></p>
                </div>
            </li>
            <li style="padding-bottom:12px;">
                <div>
                    <h3><a href="https://assistant.google.com/services/a/uid/0000000dfd7af245">Talk to Nibble Computer
                            Society</a></h3>
                    <hr>
                    <h4><b>Node.js, Google Assistant, Dialog Flow, Firebase Functions</b></h4>
                    <p>The assistant gives you information about the ncs, its projects, events and members.</p>
                </div>
            </li>
            <li style="padding-bottom:12px;">
                <div>
                    <h3><a href="http://cform.surge.sh">Cform</a></h3>
                    <hr>
                    <h4><b>Node.js, Vue.js, MongoDB, Express.js, AWS EC2, PM2</b></h4>
                    <p>It is a platform for converting boring forms into interactive conversational forms.</p>
                    <p><a href="https://github.com/shobhit1997/chatbotModel-form">Github</a></p>
                </div>
            </li>

            <li style="padding-bottom:12px;">
                <div>
                    <h3><a href="https://www.npmjs.com/package/automatesim/">Automatic Sim Feedback</a></h3>
                    <hr>
                    <h4><b>Node.js, Google Chrome's Puppeteer</b></h4>
                    <p>Automatic filling of feedback on sim.</p>
                    <p><a href="https://github.com/shobhit1997/automate_sim_feedback">Github</a></p>
                </div>
            </li>
            <li style="padding-bottom:12px;">
                <div>
                    <h3><a href="https://chat-app97.herokuapp.com/">Chat App</a></h3>
                    <hr>
                    <h4><b>Node.js, MongoDB, HTML, CSS, JSS</b></h4>
                    <p>A Chat App using socket.io where users can sign in and join a room or create a room to chat.</p>
                    <p><a href="https://github.com/shobhit1997/ChatAppNode">Github</a></p>
                </div>
            </li>
            <li style="padding-bottom:12px;">
                <div>
                    <h3><a href="/">Portfolio</a></h3>
                    <hr>
                    <h4><b>Vue.js</b></h4>
                    <p>My portfolio built on vue.js</p>
                    <p><a href="https://github.com/shobhit1997/Portfolio">Github</a></p>
                </div>
            </li>
            <li style="padding-bottom:12px;">
                <div>
                    <h3><a href="https://play.google.com/store/apps/details?id=com.hackncs.click">Infoconnect App</a></h3>
                    <hr>
                    <h4><b>Android App</b></h4>
                    <p>An android app for the <a href="http://210.212.85.155/">information portal</a> of the college with
                        features like login/signup, notice creation and push notifications.</p>
                </div>
                <p><a href="https://github.com/ncs-jss/click">Github</a></p>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: "Project"
};
</script>



// WEBPACK FOOTER //
// src/components/projectComponent.vue